import React from 'react';
import { Client } from 'api';
import Tracker from 'tracker';
import AlertActions from 'actions/alertActions';
import { AddressInput, BooleanSelectInput, Button, EmailInput, ImageUploader, NumberInput, SelectInput, TextInput, TextAreaInput } from 'components/forms';
import ImageManager from 'components/vendors/ImageManager';
/* eslint no-unused-vars: 0 */
import css from 'venues.scss';

/* Max file size for a logo is 1MB */
const MAX_FILE_SIZE = 1048576;

export default class extends React.Component {
    api = new Client();
    tracker = new Tracker();

    state = {
        saving: false,
        errors: {},
        images: [],
        event_types: [],
        venue_types: [],
        spaces: [{
            key: 0,
            name: '',
            seated_capacity: '',
            standing_capacity: '',
            seated_dinner_capacity: '',
            price: '',
            outdoor_space: '',
            images: [],
        }],
    };

    nameChanged = (value) => {
        this.setState({ name: value });
    };

    contactNameChanged = (value) => {
        this.setState({ contact_name: value });
    };

    contactEmailChanged = (value) => {
        this.setState({ contact_email: value });
    };

    contactPhoneChanged = (value) => {
        this.setState({ contact_phone: value });
    };

    addressChanged = ({ address, placeId, latitude, longitude, neighborhoodName, cityName, stateName }) => {
        this.setState({
            address: address,
            place_id: placeId,
            latitude: latitude,
            longitude: longitude,
            neighborhood_name: neighborhoodName,
            city: cityName,
            state: stateName,
        });
    };

    websiteChanged = (value) => {
        this.setState({ website: value });
    };

    descriptionChanged = (value) => {
        this.setState({ description: value });
    };

    imagesChanged = (data) => {
        this.setState({ images: data });
    };

    venueTypesChanged = (options) => {
        this.setState({ venue_types: options.map(option => option.value) });
    };

    eventTypesChanged = (options) => {
        this.setState({ event_types: options.map(option => option.value) });
    };

    cateringRequirementChanged = ({ value }) => {
        this.setState({ catering_requirement: value });
    };

    inhouseAVChanged = (checked) => {
        this.setState({ inhouse_av: checked });
    };

    inhouseTablesChanged = (checked) => {
        this.setState({ inhouse_tables: checked });
    };

    guestRoomsChanged = (checked) => {
        this.setState({ guest_rooms: checked });
    };

    facebookUrlChanged = (value) => {
        this.setState({ facebook_url: value });
    };

    instagramUrlChanged = (value) => {
        this.setState({ instagram_url: value });
    };

    pinterestUrlChanged = (value) => {
        this.setState({ pinterest_url: value });
    };

    outdoorSpaceChanged = (checked) => {
        this.setState({ outdoor_space: checked });
    };

    addSpace = (e) => {
        e.preventDefault();

        const spaces = this.state.spaces;
        spaces.push({
            key: Date.now() + Math.random(),
            name: '',
            seated_capacity: '',
            standing_capacity: '',
            seated_dinner_capacity: '',
            price: '',
            outdoor_space: '',
            images: [],
        });

        this.setState({ spaces: spaces });
    };

    removeSpace = (space) => {
        const spaces = this.state.spaces;
        spaces.splice(space, 1);

        this.setState({ spaces: spaces });
    };

    spaceValueChanged = (space, field, value) => {
        const spaces = this.state.spaces;
        spaces[space][field] = value;

        this.setState({ spaces: spaces });
    };

    spaceNameChanged = (space, value) => {
        this.spaceValueChanged(space, 'name', value);
    };

    spaceSeatedCapacityChanged = (space, value) => {
        this.spaceValueChanged(space, 'seated_capacity', value);
    };

    spaceSeatedDinnerCapacityChanged = (space, value) => {
        this.spaceValueChanged(space, 'seated_dinner_capacity', value);
    };

    spaceStandingCapacityChanged = (space, value) => {
        this.spaceValueChanged(space, 'standing_capacity', value);
    };

    spacePriceChanged = (space, value) => {
        this.spaceValueChanged(space, 'price', value);
    };

    spaceImagesChanged = (space, data) => {
        this.spaceValueChanged(space, 'images', data);
    };

    logoChanged = (data) => {
        this.setState({ logo: data });
    };

    logoStarted = (reader, upload, file) => {
        if (upload.lengthComputable && upload.total > MAX_FILE_SIZE) {
            reader.abort();

            const errors = this.state.errors;
            errors.logo = `File ${file.name} must be less than 3MB in size.`;

            this.setState({ errors: errors });
        } else {
            const errors = this.state.errors;
            errors.logo = '';
            this.setState({ errors: errors });
        }
    };

    saveVenue = (e) => {
        e.preventDefault();

        this.setState({ saving: true });

        this.api.request(`/api/venues`, {
            method: 'POST',
            data: { venue: this.state },
            success: (response) => {
                if (response.errors) {
                    const errors = {};
                    Object.keys(response.errors).forEach(field => {
                        errors[field] = response.errors[field][0];
                    });

                    this.setState({
                        saving: false,
                        errors: errors,
                    }, () => {
                        AlertActions.addAlert({
                            message: 'We were unable to save your venue. Please review the form below for errors.',
                            type: 'error',
                        });

                        window.scrollTo(0, 0);
                    });

                    return;
                }

                this.setState({
                    saving: false,
                    errors: {},
                    name: '',
                    contact_name: '',
                    contact_email: '',
                    contact_phone: '',
                    address: '',
                    place_id: '',
                    latitude: '',
                    longitude: '',
                    neighborhood_name: '',
                    city: '',
                    state: '',
                    website: '',
                    description: '',
                    venue_types: [],
                    event_types: [],
                    catering_requirement: '',
                    outdoor_space: '',
                    inhouse_av: '',
                    inhouse_tables: '',
                    guest_rooms: '',
                    facebook_url: '',
                    instagram_url: '',
                    pinterest_url: '',
                    logo: null,
                    images: [],
                    spaces: [{
                        key: 0,
                        name: '',
                        seated_capacity: '',
                        standing_capacity: '',
                        seated_dinner_capacity: '',
                        price: '',
                        outdoor_space: '',
                        images: [],
                    }],
                }, () => {
                    AlertActions.addAlert({
                        message: 'Thanks for your interest in joining our platform! Your information has been saved and will be reviewed',
                        type: 'success',
                    });

                    window.scrollTo(0, 0);
                });
            },
            error: (xhr) => {
                this.setState({ saving: false }, () => {
                    AlertActions.addAlert({
                        message: 'An unexpected error occurred. Please try again or contact us if the problem persists.',
                        type: 'error',
                    });

                    window.scrollTo(0, 0);
                    this.tracker.logEditProfileMessage('Error while saving new venue profile', xhr, this.state);
                });
            },
        });
    };

    render() {
        return (
            <div className="page-container">
                <div className="page-header">
                    <h1>Join Our Network</h1>
                </div>

                <div className="event-details">
                    <div className="new-venue">
                        <div className="new-venue__description">
                            Interested in joining our network of exceptional event venues? Just fill out the form below to get started.
                        </div>

                        <fieldset className="new-venue__fieldset">
                            <legend className="new-venue__legend">Venue Information</legend>

                            <TextInput
                                name="name"
                                label="Venue Name"
                                value={this.state.name}
                                error={this.state.errors.name}
                                onChange={this.nameChanged}
                            />

                            <TextInput
                                name="contact_name"
                                label="Contact Name"
                                value={this.state.contact_name}
                                error={this.state.errors.contact_name}
                                onChange={this.contactNameChanged}
                            />

                            <EmailInput
                                name="contact_email"
                                label="Contact Email"
                                value={this.state.contact_email}
                                error={this.state.errors.contact_email}
                                onChange={this.contactEmailChanged}
                            />

                            <TextInput
                                name="contact_phone"
                                label="Contact Phone Number"
                                value={this.state.contact_phone}
                                error={this.state.errors.contact_phone}
                                onChange={this.contactPhoneChanged}
                            />

                            <AddressInput
                                name="address"
                                label="Address"
                                value={this.state.address}
                                error={this.state.errors.address}
                                onChange={this.addressChanged}
                            />

                            <TextInput
                                name="website"
                                label="Website"
                                value={this.state.website}
                                error={this.state.errors.website}
                                onChange={this.websiteChanged}
                            />

                            <TextAreaInput
                                name="description"
                                label="Description"
                                value={this.state.description}
                                error={this.state.errors.description}
                                onChange={this.descriptionChanged}
                            />

                            <SelectInput
                                multi
                                name="venue_types"
                                label="Venue Categories (select all that apply)"
                                onChange={this.venueTypesChanged}
                                value={this.state.venue_types}
                                options={[{
                                    value: 'Studios and galleries',
                                    label: 'Studios and galleries',
                                }, {
                                    value: 'Lofts and warehouses',
                                    label: 'Lofts and warehouses',
                                }, {
                                    value: 'Cultural institutions',
                                    label: 'Cultural institutions',
                                }, {
                                    value: 'Residential spaces',
                                    label: 'Residential spaces',
                                }, {
                                    value: 'Event halls and ballrooms',
                                    label: 'Event halls and ballrooms',
                                }, {
                                    value: 'Office/coworking spaces',
                                    label: 'Office/coworking spaces',
                                }, {
                                    value: 'Restaurants and bars',
                                    label: 'Restaurants and bars',
                                }, {
                                    value: 'Hotels and conference centers',
                                    label: 'Hotels and conference centers',
                                }, {
                                    value: 'Lounges and nightclubs',
                                    label: 'Lounges and nightclubs',
                                }, {
                                    value: 'Private Club',
                                    label: 'Private Club',
                                }, {
                                    value: 'Other',
                                    label: 'Other',
                                }]}
                            />

                            <SelectInput
                                multi
                                name="event_types"
                                label="Event Types"
                                onChange={this.eventTypesChanged}
                                value={this.state.event_types}
                                options={[{
                                    value: 'Wedding/Gala',
                                    label: 'Wedding/Gala',
                                }, {
                                    value: 'Cocktail Reception',
                                    label: 'Cocktail Reception',
                                }, {
                                    value: 'Lecture/Panel',
                                    label: 'Lecture/Panel',
                                }, {
                                    value: 'Meeting',
                                    label: 'Meeting',
                                }, {
                                    value: 'Bar Mitzvah',
                                    label: 'Bar Mitzvah',
                                }, {
                                    value: 'Conference',
                                    label: 'Conference',
                                }, {
                                    value: 'Baby Shower',
                                    label: 'Baby Shower',
                                }, {
                                    value: 'Private Dinner',
                                    label: 'Private Dinner',
                                }, {
                                    value: 'Team-Building Retreat',
                                    label: 'Team-Building Retreat',
                                }, {
                                    value: 'Pop-Up Shop',
                                    label: 'Pop-Up Shop',
                                }, {
                                    value: 'Photoshoot',
                                    label: 'Photoshoot',
                                }, {
                                    value: 'Fashion Show',
                                    label: 'Fashion Show',
                                }, {
                                    value: 'Children\'s Event',
                                    label: 'Children\'s Event',
                                }]}
                            />

                            <SelectInput
                                name="catering_requirement"
                                label="Catering Requirement"
                                onChange={this.cateringRequirementChanged}
                                value={this.state.catering_requirement}
                                options={[{
                                    value: 0,
                                    label: 'In-House/Preferred Catering Required',
                                }, {
                                    value: 1,
                                    label: 'In-House/Preferred Catering Optional',
                                }, {
                                    value: 2,
                                    label: 'External Catering Only',
                                }]}
                            />

                            <BooleanSelectInput
                                name="outdoor_space"
                                label="Does your venue have outdoor space?"
                                value={this.state.outdoor_space}
                                onChange={this.outdoorSpaceChanged}
                            />

                            <BooleanSelectInput
                                name="inhouse_av"
                                label="Does your venue have in-house A/V?"
                                value={this.state.inhouse_av}
                                onChange={this.inhouseAVChanged}
                            />

                            <BooleanSelectInput
                                name="inhouse_tables"
                                label="Does your venue have in-house tables and chairs?"
                                value={this.state.inhouse_tables}
                                onChange={this.inhouseTablesChanged}
                            />

                            <BooleanSelectInput
                                name="guest_rooms"
                                label="Does your venue have guest rooms?"
                                value={this.state.guest_rooms}
                                onChange={this.guestRoomsChanged}
                            />

                            <TextInput
                                name="facebook_url"
                                label="Facebook URL (optional)"
                                value={this.state.facebook_url}
                                onChange={this.facebookUrlChanged}
                            />

                            <TextInput
                                name="instagram_url"
                                label="Instagram URL (optional)"
                                value={this.state.instagram_url}
                                onChange={this.instagramUrlChanged}
                            />

                            <TextInput
                                name="pinterest_url"
                                label="Pinterest URL (optional)"
                                value={this.state.pinterest_url}
                                onChange={this.pinterestUrlChanged}
                            />

                            <ImageUploader
                                name="logo"
                                label="Click below to upload your logo"
                                onLoadStart={this.logoStarted}
                                onChange={this.logoChanged}
                                value={this.state.logo}
                                error={this.state.errors.logo}
                            />

                            <ImageManager
                                title="Representative Venue Photos"
                                vendorImages={this.state.images}
                                onChange={this.imagesChanged}
                            />
                        </fieldset>

                        <fieldset className="new-venue__fieldset">
                            <legend className="new-venue__legend">Venue Spaces</legend>

                            <div className="new-venue__space__copy">
                                A "space" is any part of your venue that can rented out for events; some venues are just one space whereas others have multiple spaces that can be rented out individually. If your venue contains just one space, please provide your venue details below and make the title of the space the same as your venue name. If your venue contains multiple spaces, please provide separate names and details for each below.
                            </div>

                            {this.state.spaces.map((space, i) => {
                                return (
                                    <div className="new-venue__space" key={space.key}>
                                        <TextInput
                                            name={`space_${space.key}_name`}
                                            label="Space Name"
                                            value={space.name}
                                            onChange={this.spaceNameChanged.bind(this, i)}
                                        />

                                        <NumberInput
                                            name={`space_${space.key}_seated_capacity`}
                                            label="Theater-Style Capacity"
                                            value={space.seated_capacity}
                                            onChange={this.spaceSeatedCapacityChanged.bind(this, i)}
                                        />

                                        <NumberInput
                                            name={`space_${space.key}_seated_dinner_capacity`}
                                            label="Seated Dinner/Classroom Capacity"
                                            value={space.seated_dinner_capacity}
                                            onChange={this.spaceSeatedDinnerCapacityChanged.bind(this, i)}
                                        />

                                        <NumberInput
                                            name={`space_${space.key}_standing_capacity`}
                                            label="Standing Capacity"
                                            value={space.standing_capacity}
                                            onChange={this.spaceStandingCapacityChanged.bind(this, i)}
                                        />

                                        <TextInput
                                            name={`space_${space.key}_price`}
                                            label="Price"
                                            value={space.price}
                                            onChange={this.spacePriceChanged.bind(this, i)}
                                        />

                                        <ImageManager
                                            title="Photos of Space"
                                            vendorImages={space.images}
                                            onChange={this.spaceImagesChanged.bind(this, i)}
                                        />

                                        <div className="new-venue__space__actions">
                                            {this.state.spaces.length > 1 && <Button submitLabel="Remove Space" onClick={this.removeSpace.bind(this, i)} />}
                                        </div>
                                    </div>
                                );
                            })}

                            <div className="new-venue__add-space">
                                <Button submitLabel="Add Space" onClick={this.addSpace} />
                            </div>
                        </fieldset>

                        <div className="new-venue__actions">
                            <Button
                                buttonClass="button button__primary"
                                submitLabel="Save Venue"
                                actionLabel="Saving"
                                onClick={this.saveVenue}
                                saving={this.state.saving}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/assets/javascripts/views/Venues.jsx